import * as intakeForms from '@wix/auto_sdk_intake-forms_intake-forms';
import * as intakeFormSubmissions from '@wix/auto_sdk_intake-forms_intake-form-submissions';

export { intakeForms, intakeFormSubmissions };
